import { gql } from "@apollo/client";

export const GET_ATTRIBUTES = gql`
  query getAttributes(
    $key: AttributeFilterKey
    $filterValue: String
    $paginationLimit: Int = 25
  ) {
    attributes(
      filters: [{ key: $key, value: $filterValue }]
      pagination: { limit: $paginationLimit }
    ) {
      pagination {
        count
      }
      items {
        __typename
        ... on Color {
          id
          title
          slug
          hex
        }
        ... on Brand {
          id
          title
          slug
        }
        ... on Label {
          id
          title
        }
        ... on Material {
          id
          title
          slug
        }
        ... on Style {
          id
          title
          slug
        }
        ... on Designer {
          id
          title
        }
        ... on UsageSign {
          id
          title
        }
        ... on AdditionalInfo {
          id
          title
        }
      }
    }
  }
`;

export const GET_ATTRIBUTES_BY_KEY = gql`
  query getAttributesByKey(
    $key: AttributeFilterKey
    $value: String!
    $lang: Language = EN
  ) {
    attributesByKey(key: $key, value: $value) {
      ... on Color {
        id
        title(lang: $lang)
        slug
        hex
      }
      ... on Brand {
        id
        title
        slug
      }
      ... on Label {
        id
        title
      }
      ... on Material {
        id
        title(lang: $lang)
        slug
      }
      ... on Style {
        id
        title(lang: $lang)
        slug
      }
      ... on Designer {
        id
        title
      }
      ... on UsageSign {
        id
        title
        slug
      }
      ... on AdditionalInfo {
        id
        slug
        title
      }
      ... on Artist {
        id
        slug
        title
      }
    }
  }
`;
